import React, { useCallback, useEffect, useState } from "react";

const ImageCarousel = () => {
  const images = [
    "/img/team/cliente1.png",
    "/img/team/cliente2.png",
    "/img/team/cliente3.png",
    "/img/team/cliente4.png",
    "/img/team/cliente5.png",
    "/img/team/cliente6.png",
    "/img/team/cliente7.jpg",
    "/img/team/cliente8.jpeg"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const totalImages = images.length;

  const handleNext = useCallback(() => {
    setIsTransitioning(true);
    setIsPaused(true);
    setCurrentIndex((prevIndex) => (prevIndex >= totalImages - 1 ? 0 : prevIndex + 1));
  }, [totalImages]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        handleNext();
      }
    }, 1000); // Cambié el tiempo a 3 segundos (ajústalo según prefieras)

    return () => clearInterval(interval);
  }, [isPaused, handleNext]);

  const handleTransitionEnd = () => {
    setIsPaused(false);
  };

  const getTranslateX = () => `-${currentIndex * 100}%`;

  return (
    <div className="carousel-container" style={{ overflow: "hidden", width: "100%" }}>
      <div
        className="carousel"
        style={{
          display: "flex",
          transform: `translateX(${getTranslateX()})`,
          transition: isTransitioning ? "transform 1s ease-in-out" : "none",
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {images.map((image, index) => (
          <div
            className="carousel-item"
            key={index}
            style={{
              flex: "0 0 100%",
              display: "flex",
              justifyContent: "center",
              marginBottom: "200px",
              alignItems: "center",
              height: "320px", //altura tarjeta
            }}
          >
            <div className="card">
              <img src={image} alt={`Cliente ${index + 1}`} className="carousel-image" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const Marcas = () => {
  return (
    <div
      id="marcas"
      className="text-center"
      style={{
        background: '#fff',
        padding: '100px 0',
        height: '450px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div className="container">
      <div className="col-md-8 col-md-offset-2 section-title" style={{ marginTop: "100px" }}>
          <h2> </h2>
          <p>
          Hemos desarrollado una sólida relación comercial con socios
que han añadido un alto valor a nuestra red comercial.
Esta asociación, combinada con nuestra tecnología y
modelo de negocio, nos hace únicos en el mercado de las
máquinas expendedoras.
          </p>
        </div>
        <ImageCarousel />
      </div>
    </div>
  );
};

export default Marcas;
